<!--<span *ngIf="safeType" [innerHtml]="field.labelLocalized | safe: safeType"></span>-->
<!--<span *ngIf="safeType" [innerHtml]="field.labelLocalized"></span>-->
<span *ngIf="labelLocalized$" [innerHtml]="labelLocalized$ | async | safe: safeType"></span>
<span *ngIf="!labelLocalized$" [innerHtml]="field.labelLocalized | safe: safeType"></span>
